import React from "react";
import SurveyForm from "../../components/Survey/SurveyForm";

function SurveyEdit() {
  return <SurveyForm mode="edit" />;
}

export default SurveyEdit;
